//-----------
// calc rank
//-----------
export default function calcRank(combatant) {
  let rank;
  if (combatant.status == "Inactive") {
    rank = -999;
  } else {
    rank = combatant.sr + combatant.sr_roll + combatant.sr_adj;
  }
  return rank;
}
